import { chain, compact } from "lodash"

export const GROUP_LABELS = {
  RISK_MODEL: "Risk Model",
  FACTOR_SENSITIVITY: "Factor Sensitivity",
  LICENSED_CONTENT_SETS: "Licensed",
  PROPRIETARY_CONTENT_SETS: "Proprietary",
  CUSTOM: "Custom",
}

export const GROUP_IDS = {
  RISK_MODEL: "riskModel",
  FACTOR_SENSITIVITY: "factorSensitivity",
  LICENSED_CONTENT_SETS: "licensedContentSets",
  PROPRIETARY_CONTENT_SETS: "proprietaryContentSets",
  CUSTOM: "custom",
}

function getRiskModelItem(id, label) {
  return {
    id,
    label,
    groupId: GROUP_IDS.RISK_MODEL,
    groupLabel: GROUP_LABELS.RISK_MODEL,
  }
}

function getFactorSensitivityItem(id, label) {
  return {
    id,
    label,
    groupId: GROUP_IDS.FACTOR_SENSITIVITY,
    groupLabel: GROUP_LABELS.FACTOR_SENSITIVITY,
  }
}

export function buildDefaultViewItems(isOpPro) {
  return compact([
    getRiskModelItem("summary", "Summary"),
    getRiskModelItem("exposure", "Exposure"),
    getRiskModelItem("performance", "Performance"),
    !isOpPro && getRiskModelItem("risk", "Risk"),
    getRiskModelItem("beta", "Beta"),
    getRiskModelItem("marginalContribution", "Marginal Contribution"),
    getFactorSensitivityItem("predictedFactorSensitivity", "Predicted Factor Sensitivity"),
    getFactorSensitivityItem("historicalFactorSensitivity", "Historical Factor Sensitivity"),
  ])
}

export function buildContentSetViewItems(licensedContentSets, proprietaryContentSets) {
  const licensed = chain(licensedContentSets)
    .sortBy("name")
    .map((contentSet) => ({
      id: contentSet.id,
      label: contentSet.name,
      groupId: GROUP_IDS.LICENSED_CONTENT_SETS,
      groupLabel: GROUP_LABELS.LICENSED_CONTENT_SETS,
    }))
    .value()
  const proprietary = chain(proprietaryContentSets)
    .sortBy("name")
    .map((contentSet) => ({
      id: contentSet.id,
      label: contentSet.name,
      groupId: GROUP_IDS.PROPRIETARY_CONTENT_SETS,
      groupLabel: GROUP_LABELS.PROPRIETARY_CONTENT_SETS,
    }))
    .value()
  return [...licensed, ...proprietary]
}

export function mergeItemsWithOrderAndSecondaryAction(sections, { icon: SecondaryActionIcon, onOpenInNewTab }) {
  return sections.flat()
    .map((item, index) => {
      const itemWithOrder = { ...item, order: index + 1 }
      const canOpenInNewTab = !item.disabled && !item.onSelect && SecondaryActionIcon && onOpenInNewTab
      if (canOpenInNewTab) {
        itemWithOrder.secondaryAction = {
          icon: SecondaryActionIcon,
          onClick: () => onOpenInNewTab(item),
        }
      }
      return itemWithOrder
    })
}
